import { render, staticRenderFns } from "./CarregandoTipoVinculo.vue?vue&type=template&id=4bf293d8&scoped=true"
import script from "./CarregandoTipoVinculo.vue?vue&type=script&lang=js"
export * from "./CarregandoTipoVinculo.vue?vue&type=script&lang=js"
import style0 from "./CarregandoTipoVinculo.vue?vue&type=style&index=0&id=4bf293d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf293d8",
  null
  
)

export default component.exports